
import Vue from 'vue';
import store from '@/store';
import _ from 'lodash';
import QrcodeVue from 'qrcode.vue';
import { TranslationService } from '@/services/TranslationService';
import { helperFns } from '@/helpers';
import { convertToArabicNumber } from '@/helpers/convertToArabicNumber';
import { currencyToWords } from '@/helpers/currency';
import { dateFormat } from '@/helpers/dateFormat';
import { numberToArabic } from '@/helpers/numberToArabic';
import { numFormat } from '@/helpers/numFormat';
import { qrCodeValue } from '@/helpers/qrCodeValue';

export default Vue.extend({
  components: { QrcodeVue },
  props: {
    input: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} }
  },
  data(): { arabicAddress: string } {
    return { arabicAddress: '' }
  },
  computed: {
    paymentDetails: function() : any {
      return this.getVariable(this.input.variable);
    },
    customerDetails: function(): any {
      if(!_.get(this.input,'config.customerDetailsVariable')) return {};
      return this.getVariable(this.input.config.customerDetailsVariable) || {};
    },
    companyDetail: function(): any {
      return store.state.staticData['company-detail']
    },
    contactName: function(): string {
      let contactName = _.get(this.paymentDetails, 'contact.firstName', '');
      const contactDetails = _.find(this.customerDetails.contactDetails, (contactData: any) => contactData.firstName == contactName);
      contactName = contactDetails ? helperFns['contactName'](contactDetails) : contactName;
      return contactName;
    },
    qrCodeValue: function(): string {
      return qrCodeValue({ companyDetails: this.companyDetail, docDetails: this.paymentDetails, total: this.paymentDetails.expectedAmountReceived, vat: 0 });
    },
    amountInWords: function(): string {
      return currencyToWords(this.paymentDetails.expectedAmountReceived);
    },
    amountInArabicWords: function(): string {
      return numberToArabic(this.paymentDetails.expectedAmountReceived);
    },
    formattedAmount: function(): string | number {
      return numFormat((this.paymentDetails.amountReceived || this.paymentDetails.expectedAmountReceived || 0));
    }
  },
  methods: {
    translateToArabic: function(text: string) {
      if(!text) return '';
      return TranslationService.translate(text, 'ar');
    },
    convertToArabicNo: function(numValue: number): string {
      return convertToArabicNumber(numValue);
    },
    formatDate: function(date: string, format?: string) {
      return dateFormat(date, format);
    }
  }
})
